module.exports = __webpack_public_path__ + "assets/img/kitchen_20.08814e28.jpg";